import React from 'react';
import { useRecordingNavigationGuard } from '../../context/RecordingNavigationGuard';
import { Box, ButtonBase, Chip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import ListIcon from '@mui/icons-material/List';
import DescriptionIcon from '@mui/icons-material/Description';
import MicIcon from '@mui/icons-material/Mic';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { ScribeButton, ScribePanel, ScribePanelHeader, ScribeText } from '../../components/scribe/ScribeUI';
import { scribeTokens as ui } from '../../components/scribe/tokens';

const workflows = [
  { mode: 'live-consultation', title: 'Transcribe', description: 'Convert speech or recordings to text', icon: MicIcon, tour: 'patient-workflow-live' },
  { mode: 'write-document', title: 'Write', description: 'Create a report from transcripts, notes or files', icon: DescriptionIcon, tour: 'patient-workflow-write' },
  { mode: 'transcribe-recording', title: 'Recordings', description: 'Upload audio', icon: UploadFileIcon },
];

export default function ConsultationWorkflowPicker({ beforeChangeWorkflow, filesToggleHidden = false, isRecognizing, resetConsultationUI, setShowSidebar, setShowWorkflowSelector, setWorkflowMode, showSidebar, showWorkflowSelector, workflowMode }) {
  const { confirmNavigation } = useRecordingNavigationGuard();
  const changeWorkflow = (mode, reset = false) => {
    if (beforeChangeWorkflow && !beforeChangeWorkflow(mode)) return;
    if (!confirmNavigation()) return;
    setWorkflowMode(mode);
    if (reset && !isRecognizing) resetConsultationUI();
  };
  return <ScribePanel sx={{ mb: 2 }}>
    <ScribePanelHeader title="Select Workflow" expanded={showWorkflowSelector} onToggle={() => setShowWorkflowSelector(!showWorkflowSelector)}
      badge={workflowMode && <Chip label={workflows.find(item => item.mode === workflowMode)?.title} size="small" sx={{ bgcolor: ui.colors.brandSoft, color: ui.colors.brand }} />}
      actions={!filesToggleHidden && workflowMode !== 'live-consultation' && <ScribeButton variant="text" size="small" startIcon={<ListIcon fontSize="small" />} onClick={() => setShowSidebar(!showSidebar)}>{showSidebar ? 'Hide files' : 'Show files'}</ScribeButton>} />
    {showWorkflowSelector && <Box sx={{ px: 2, pb: 2 }}>
      <Grid container spacing={2}>
        {workflows.filter(item => item.mode !== 'transcribe-recording').map(({ mode, title, description, icon: Icon, tour }) => {
          const selected = workflowMode === mode;
          return <Grid key={mode} size={{ xs: 12, sm: 6 }}>
            <ButtonBase aria-label={title} aria-pressed={selected} data-tour={tour} onClick={() => changeWorkflow(mode, mode === 'live-consultation')}
              sx={{ p: 2, width: '100%', height: '100%', minHeight: 144, display: 'flex', flexDirection: 'column', gap: 1, borderRadius: `${ui.radius.panel}px`,
                border: `1px solid ${selected ? ui.colors.brand : ui.colors.border}`, bgcolor: selected ? ui.colors.brandSoft : ui.colors.surface,
                '&:hover': { bgcolor: ui.colors.brandSoft }, '&.Mui-focusVisible': { outline: `2px solid ${ui.colors.brand}`, outlineOffset: 2 } }}>
              <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: selected ? ui.colors.brand : ui.colors.disabled, display: 'grid', placeItems: 'center' }}>
                <Icon sx={{ fontSize: ui.iconSize.normal, color: selected ? ui.colors.surface : ui.colors.secondary }} />
              </Box>
              <ScribeText kind="section" component="span">{title}</ScribeText>
              <ScribeText kind="helper" component="span" sx={{ color: ui.colors.secondary, textAlign: 'center' }}>{description}</ScribeText>
            </ButtonBase>
          </Grid>;
        })}
      </Grid>
    </Box>}
  </ScribePanel>;
}
